module.exports = "<div class=\"col-xs-12\">\n    <div class=\"video-player-component\" *ngIf=\"resource\" [ngSwitch]=\"resource.resourceType\">\n      <mp-brightcove\n        *ngSwitchCase=\"ResourceType.Brightcove\"\n        [videoResource]=\"securedResource\"\n      >\n      </mp-brightcove>\n\n      <div class=\"row\" *ngSwitchDefault>\n        <mp-flowplayer\n        [uri]=\"securedResource.uri\"\n        height=\"93vh\"\n        rendererType=\"normal\"\n        ></mp-flowplayer>\n      </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/video-players/video-player/video-player.html
// module id = He2g
// module chunks = 3